// Special thanks gallery: same behaviour as the product panel's gallery (big square + thumbnails, full-screen
// lightbox on click), without the product/variant logic. Only rendered when a block has 2+ pictures.
if (!customElements.get('rr-thanks-gallery')) {
  customElements.define(
    'rr-thanks-gallery',
    class RrThanksGallery extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-rr-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-rr-thumb]')];
        this.lightbox = this.querySelector('[data-rr-lightbox]');
        this.figures = [...this.lightbox.querySelectorAll('.rr-lightbox__media')];
        this.index = 0;

        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onTouchStart = (event) => (this.touchX = event.touches[0].clientX);
        this.onTouchEnd = (event) => {
          const delta = event.changedTouches[0].clientX - this.touchX;
          if (Math.abs(delta) < 50) return;
          const direction = delta < 0 ? 1 : -1;
          this.lightbox.open ? this.stepLightbox(direction) : this.show(this.index + direction);
        };

        this.addEventListener('click', this.onClick);
        this.lightbox.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd);
      }

      // Theme editor re-renders the section on change, which disconnects this element.
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        if (this.lightbox.open) this.lightbox.close();
      }

      onClick(event) {
        if (this.lightbox.contains(event.target)) return this.onLightboxClick(event);
        if (event.target.closest('[data-rr-prev]')) return this.show(this.index - 1);
        if (event.target.closest('[data-rr-next]')) return this.show(this.index + 1);

        const thumb = event.target.closest('[data-rr-thumb]');
        if (thumb) return this.show(this.thumbs.indexOf(thumb));

        if (event.target.closest('[data-rr-lightbox-open]')) this.openLightbox(this.index);
      }

      onKeyDown(event) {
        if (event.key === 'ArrowLeft') this.stepLightbox(-1);
        if (event.key === 'ArrowRight') this.stepLightbox(1);
      }

      show(index) {
        const total = this.slides.length;
        this.index = (index + total) % total;
        this.slides.forEach((slide, i) => (slide.hidden = i !== this.index));
        this.thumbs.forEach((thumb, i) => thumb.toggleAttribute('aria-current', i === this.index));
      }

      openLightbox(index) {
        this.showLightboxFigure(index);
        if (!this.lightbox.open) this.lightbox.showModal();
      }

      stepLightbox(direction) {
        const total = this.figures.length;
        this.showLightboxFigure((this.lightboxIndex + direction + total) % total);
      }

      showLightboxFigure(index) {
        this.lightboxIndex = index;
        this.figures.forEach((figure, i) => {
          figure.hidden = i !== index;
          if (i === index) figure.querySelector('img')?.setAttribute('loading', 'eager');
        });
        const pad = (n) => String(n).padStart(2, '0');
        this.lightbox.querySelector('[data-rr-lightbox-count]').textContent = `${pad(index + 1)} / ${pad(
          this.figures.length
        )}`;
      }

      onLightboxClick(event) {
        if (event.target.closest('[data-rr-lightbox-prev]')) return this.stepLightbox(-1);
        if (event.target.closest('[data-rr-lightbox-next]')) return this.stepLightbox(1);
        // Close button, or a click on the empty area around the picture.
        const stage = this.lightbox.querySelector('[data-rr-lightbox-stage]');
        if (
          event.target.closest('[data-rr-lightbox-close]') ||
          event.target === this.lightbox ||
          event.target === stage ||
          event.target.classList.contains('rr-lightbox__media')
        ) {
          this.lightbox.close();
        }
      }
    }
  );
}
